import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { spaceMixin, mediaMixin, Spacer, Heading } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { omitUndefined } from '../../utils/lodash.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './RefinanceCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './RefinanceCalculator.utils.js';
import { LOAN_TERM_IN_MONTHS, LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import RefinanceFields from './RefinanceFields.js';
import SavingsHeader from './SavingsHeader.js';
import RefinanceBarGraph from './RefinanceBarGraph.js';
import RefinanceLegend from './RefinanceLegend.js';
import RefinanceLineGraph from './RefinanceLineGraph.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledCalculatorForm = /*#__PURE__*/styled(CalculatorForm).withConfig({
  componentId: "sc-ut9ijx-0"
})(["padding-bottom:", ";display:flex;flex-direction:column-reverse;", ";"], spaceMixin('md'), mediaMixin('md', css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            flex-direction: row;\n            &:first-child,\n            &:last-child {\n                flex-grow: 1;\n            }\n            align-items: center;\n        "])))));
var StyledRefinanceGraphs = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ut9ijx-1"
})(["display:flex;flex-direction:column;"]);
var StyledBreakdown = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ut9ijx-2"
})(["display:flex;flex-direction:column;", ";"], mediaMixin('lg', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n            flex-direction: row;\n        "])))));
var StyledLegend = /*#__PURE__*/styled(RefinanceLegend).withConfig({
  componentId: "sc-ut9ijx-3"
})(["width:100%;margin-bottom:", ";", ";"], spaceMixin('md'), mediaMixin('lg', css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n            margin-bottom: 0;\n            margin-left: ", ";\n        "])), spaceMixin('lg'))));
var StyledBreakEven = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ut9ijx-4"
})(["display:none;", ";width:100%;"], mediaMixin('md', css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n            display: block;\n        "])))));
var StyledRefinanceFields = /*#__PURE__*/styled(RefinanceFields).withConfig({
  componentId: "sc-ut9ijx-5"
})(["", ";"], mediaMixin('lg', css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n            margin-right: ", ";\n        "])), spaceMixin('md'))));
var RefinanceCalculator = function RefinanceCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  return /*#__PURE__*/React.createElement(StyledCalculatorForm, {
    fieldStorageKey: "refinanceFields",
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.loanAmount.name] = 200000, _Object$assign[FieldConfig.rate.name] = 5, _Object$assign[FieldConfig.term.name] = LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year], _Object$assign[FieldConfig.originationYear.name] = new Date().getFullYear() - 6, _Object$assign[FieldConfig.newLoanAmount.name] = 195000, _Object$assign[FieldConfig.newTerm.name] = LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year], _Object$assign[FieldConfig.newRate.name] = 4.35, _Object$assign[FieldConfig.fees.name] = 1000, _Object$assign[FieldConfig.cashOut.name] = 0, _Object$assign[FieldConfig.rollFees.name] = false, _Object$assign), omitUndefined(defaultValues)),
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(StyledRefinanceFields, null), /*#__PURE__*/React.createElement(StyledRefinanceGraphs, null, /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "lg"
  }, /*#__PURE__*/React.createElement(SavingsHeader, null)), /*#__PURE__*/React.createElement(StyledBreakdown, null, /*#__PURE__*/React.createElement(RefinanceBarGraph, null), /*#__PURE__*/React.createElement(StyledLegend, null)), /*#__PURE__*/React.createElement(StyledBreakEven, null, /*#__PURE__*/React.createElement(Heading, {
    level: "4",
    className: "zsg-content_collapsed"
  }, "Total Savings / Break Even"), /*#__PURE__*/React.createElement(RefinanceLineGraph, null))));
};
RefinanceCalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
RefinanceCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var RefinanceCalculator$1 = RefinanceCalculator;

export { RefinanceCalculator$1 as default };
